/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Program } from '../../models/program';

export interface GetLoyaltyProgram$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
}

export function getLoyaltyProgram(http: HttpClient, rootUrl: string, params: GetLoyaltyProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Program>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyProgram.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Program>;
    })
  );
}

getLoyaltyProgram.PATH = '/loyalty/programs/{programId}';
